/** How long typing must pause before on-canvas text is committed. */
export const TEXT_COMMIT_DEBOUNCE_MS = 500;

/**
 * Debounces committing on-canvas typing into the item model (and so into poster history), and lets callers land the
 * pending commit immediately — e.g. before undo, so the last typed chunk is in history and no late commit lands after.
 */
export class DebouncedTextCommit {
  #timeoutId = 0;
  #pendingCommit: (() => Promise<void>) | null = null;

  public schedule(commit: () => Promise<void>, delayMs: number): void {
    window.clearTimeout(this.#timeoutId);
    this.#pendingCommit = commit;
    this.#timeoutId = window.setTimeout(() => {
      void this.flush();
    }, delayMs);
  }

  public async flush(): Promise<void> {
    window.clearTimeout(this.#timeoutId);
    this.#timeoutId = 0;
    const commit = this.#pendingCommit;
    this.#pendingCommit = null;
    await commit?.();
  }

  /** Drops the pending commit without running it — for a change that supersedes the typed text. */
  public cancel(): void {
    window.clearTimeout(this.#timeoutId);
    this.#timeoutId = 0;
    this.#pendingCommit = null;
  }
}
